import React, { useState, useContext } from 'react';

import { CatalogContext } from 'src/pages/CatalogPage/CatalogPage';
import {
  SearchBarContainer,
  ShowCompletedLots,
  KeywordSearch,
  LotSearch,
  SearchBars,
  CompactToggle,
  SearchButton,
  GoButton,
} from 'src/pages/CatalogPage/components/CatalogHead/SearchBar/SearchBar.style';
import { Input } from '@riac/design-system';
import { Checkbox } from 'src/components/Input/CheckboxInput/CheckboxInput';
import { ToggleInput } from 'src/components/Input/ToggleInput/ToggleInput';
import { ICatalogSearch } from 'src/pages/CatalogPage/CatalogPage.i';
import { FaArrowRight, FaSearch } from 'react-icons/fa';

interface ISearchBar {
  complete: boolean;
  onlyLotsBidOn: boolean;
  lotNumber: string;
  keywords: string;
  updateSearch: ICatalogSearch;
}

export const SearchBar = (props: ISearchBar) => {
  const [searchInput, setSearchInput] = useState(props.keywords);
  const [lotInput, setLotInput] = useState(props.lotNumber);
  const { auctionLive, compactMode, setCompactMode } = useContext(CatalogContext);
  function toggleCompletedLots(e) {
    props.updateSearch({ pageNumber: 1, complete: e.target.checked });
  }

  function toggleLotsBidOn(e) {
    props.updateSearch({ pageNumber: 1, onlyLotsBidOn: e.target.checked });
  }

  function keywordChange(e) {
    setSearchInput(e);
  }

  function gotoLotChange(e) {
    setLotInput(e.replace(/[^0-9]/g, ''));
  }

  function doSearch() {
    setLotInput('');
    props.updateSearch({
      pageNumber: 1,
      keywords: encodeURIComponent(searchInput),
      lotNumber: '',
    });
  }

  function doGotoLot() {
    setSearchInput('');
    props.updateSearch({ lotNumber: lotInput });
  }

  return (
    <SearchBarContainer>
      <SearchBars>
        <div>
          <KeywordSearch>
            <Input
              type='text'
              label='Search'
              value={searchInput}
              inverted
              onChange={keywordChange}
              onKeyDown={(evt) => {
                if(evt.key === 'Enter')
                {
                  doSearch();
                }
              }}
              after={
                <SearchButton onPress={doSearch}>
                  <FaSearch/> Search
                </SearchButton>
              }
            />
          </KeywordSearch>
        </div>
        <div>
          <LotSearch>
            <Input
              type='text'
              label='Go to Lot #'
              value={lotInput}
              inverted
              onChange={gotoLotChange}
              onKeyDown={(evt) => {
                if(evt.key === 'Enter')
                {
                  doGotoLot();
                }
              }}
              after={
                <GoButton onPress={doGotoLot}>
                  <FaArrowRight/>
                </GoButton>
              }
            />
          </LotSearch>
        </div>
      </SearchBars>
      <CompactToggle>
        <ToggleInput
          label='Compact Mode'
          on={compactMode === 'true'}
          id='compact-mode'
          onClick={() => setCompactMode(compactMode === 'true' ? 'false' : 'true')}
        />
      </CompactToggle>
      {auctionLive && (
        <ShowCompletedLots>
          <label htmlFor='catalog_completedlots'>
            <Checkbox
              id='catalog_completedlots'
              name='catalog_completedlots'
              onChange={toggleCompletedLots}
              checked={props.complete}
            />
            Include Completed Lots
          </label>
        </ShowCompletedLots>
      )}
      <ShowCompletedLots>
        <label htmlFor='catalog_lotsBidOn'>
          <Checkbox
            id='catalog_lotsBidOn'
            name='catalog_lotsBidOn'
            onChange={toggleLotsBidOn}
            checked={props.onlyLotsBidOn}
          />
          Include Only Lots I Bid On
        </label>
      </ShowCompletedLots>
    </SearchBarContainer>
  );
};
